import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as httpClient from "../../../../util/httpClient";
import * as MonitorActions from "../../../../store/monitorService/actions";
import { Notification } from "../../../common/Notification";
import { ApplicationState } from "../../../../store";
import { useTranslation } from "react-i18next";
import SocialMediaNotSupported from "../../../Dialogs/lostWallet/SocialMediaNotSupported";
import { DialogComponent } from "../../../common/DialogComponent";
import { getSocialNetworkAccountStatus } from "../../../../store/service";
import YoutubeIcon from "../../../../Assets/images/yt_icon.png";
import TwitterXIcon from "../../../../Assets/images/icon-x-black.svg";

interface IProps {
    socialMediaName: string;
    accountInformation?: string;
    active?: boolean;
    networkId: number;
    socialMediaId?: string;
    addLinkText: string;
}

type ISocialMediaProps = IProps;

const SocialMedia: React.FunctionComponent<ISocialMediaProps> = (props) => {
    const { t: tLang } = useTranslation();
    const renderSiteInIFrame: any = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.renderInIframe
            ? state.configurationState.configuration.partnerConfig.renderInIframe
            : false
    );

    var isSafari = /^((?!chrome|android).)*safari/i.test(window.navigator.userAgent);

    const dispatch = useDispatch();
    const [active, setActive] = useState(props.active);
    const [isLoading, setIsLoading] = useState(false);
    const requestMonitors = () => dispatch(MonitorActions.actionCreators.requestMonitors(true));
    const [isNotSupportVisible, setIsNotSupportVisible] = useState(false);

    const tooltipMsgs = {
        youtube: tLang("identityVault.monitoredInformation.socialMediaWidget.tooltipMsg"),
        instagram: tLang("identityVault.monitoredInformation.socialMediaWidget.instagramTooltipMsg"),
    };
    let win: any = null;

    const callBackURL = window.location.origin + "/app/social-media-callback";

    const closeNotSupportDialog = (): any => {
        setIsNotSupportVisible(false);
    };

    useEffect(() => {
        setActive(props.active);
    }, [props.active]);

    const getTooltipMsg = (socialMediaName: string) => {
        return tooltipMsgs[socialMediaName.toLowerCase()] || '';
    };

    const popupWindow = (url: string, title: string, win: Window, width: number, height: number) => {
        var y = 100;
        var x = 100;
        // We need to put this in a try/catch because accessing the window.top could
        // fail if we're trying to exercise this code inside an IFRAME

        try {
            y = win.top.outerHeight / 2 + win.top.screenY - height / 2;
            x = win.top.outerWidth / 2 + win.top.screenX - width / 2;
        } catch {
            console.warn("could not access top window to compute screen center; defaulting");
        }
        return win.open(
            url,
            title,
            `resizable=yes, scrollbars=yes, toolbar=yes, menubar=no, location=no, directories=no, status=yes', width=${width}, height=${height}, top=${y}, left=${x}`
        );
    };

    const getSocialMediaPopUpURL = (url: string) => {
        const splitedUrl = url.split("&");
        let popUpUrl = "";
        splitedUrl.map((urlProperty) => {
            if (!urlProperty.startsWith("origin")) {
                popUpUrl = `${popUpUrl}${urlProperty}&`;
            }
            return urlProperty;
        });

        popUpUrl += `origin=${callBackURL}`;
        return popUpUrl;
    };

    const getTwitterPopupURL = (url: string) => {
        const splitedUrl = url.split("&");
        let popUpUrl = "";
        splitedUrl.map((urlProperty) => {
            if (!urlProperty.startsWith("origin") && !urlProperty.startsWith("application_id")) {
                popUpUrl = `${popUpUrl}${urlProperty}&`;
            }
            return urlProperty;
        });

        popUpUrl += `origin=${callBackURL}`;
        console.log('getTwitterPopupURL SocialMedia.tsx',popUpUrl);
        return popUpUrl;
    };

    const getYoutubePopupURL = (url: string) => {
        return url;
    };

    const getPopupURL = (data: any) => {
        const network = data.networkName?.toLowerCase();
        if (network === "youtube") return getYoutubePopupURL(data.socialAuthURL);
        if (network === "twitter" || network === "x") return getTwitterPopupURL(data.socialAuthURL);
        return getSocialMediaPopUpURL(data.socialAuthURL);
    };

    const getSocialAccountUpdate = () => {
        getSocialNetworkAccountStatus({
            "Network-Type": props.socialMediaName ? props.socialMediaName.toLowerCase() : "",
        }).then((res) => {
            if (res.isAccountActive) {
                window.location.reload();
            } else {
                setTimeout(() => {
                    getSocialAccountUpdate();
                }, 10000);
            }
        });
    };

    const addAccount = async (event: any) => {
        // Send an event to the data layer
        window.addToDataLayer({ event: "Add " + props.socialMediaName + " Account" });

        if (isSafari) {
            if (renderSiteInIFrame) {
                //  Close the previous popup if it's open
                if (win != null && !win.closed) {
                    win.close();
                }
                win = window.open("", "_blank");
            } else {
                var y = 100;
                var x = 100;
                // We need to put this in a try/catch because accessing the window.top could
                // fail if we're trying to exercise this code inside an IFRAME

                try {
                    y = window.top.outerHeight / 2 + window.top.screenY - 600 / 2;
                    x = window.top.outerWidth / 2 + window.top.screenX - 600 / 2;
                } catch {
                    console.warn("could not access top window to compute screen center; defaulting");
                }

                if (win != null && !win.closed) {
                    win.close();
                }
                win = window.open(
                    "",
                    "_blank",
                    `resizable=yes, scrollbars=yes, toolbar=yes, menubar=no, location=no, directories=no, status=yes', width=${600}, height=${600}, top=${y}, left=${x}`
                );
            }
        }

        const requestBody = {
            "network-id": props.networkId,
            origin: window.location.origin,
        };

        try {
            // Await the response from the API call
            const data = await httpClient.sendRequest("POST", `api/zeroFOX/getSocialNetworkInfo`, requestBody);

            const popupURL = getPopupURL(data);

            if (renderSiteInIFrame) {
                // Open the pop-up in a new window/tab

                if (isSafari) {
                    win.location.href = popupURL;
                } else {
                    win = window.open(popupURL, "_blank");
                }

                setTimeout(() => {
                    getSocialAccountUpdate();
                }, 10000);
            } else {
                // Call the popupWindow function for non-Safari browsers

                if (isSafari) {
                    win.location.href = popupURL;
                } else {
                    popupWindow(popupURL, "popupWindow", window, 600, 600);
                }
            }
        } catch (error) {
            // Handle any errors from the API call
            Notification({
                type: "error",
                title: tLang("identityVault.monitoredInformation.socialMediaWidget.toasterMessage.authAccountError.title"),
                message: tLang("identityVault.monitoredInformation.socialMediaWidget.toasterMessage.authAccountError.message"),
                duration: 0,
            });
        }
    };

    const removeAccount = (event: any) => {
        window.addToDataLayer({ event: "Remove " + props.socialMediaName + " Account" });
        const monitorId = props.socialMediaId?.trim();
        const requestBody = {
            "monitor-id": monitorId,
        };

        setIsLoading(true);
        httpClient
            .sendRequest("POST", `api/zeroFOX/deleteMonitor`, requestBody)
            .then((data) => {
                setIsLoading(false);
                requestMonitors();
                Notification({
                    type: "success",
                    title: tLang("identityVault.monitoredInformation.socialMediaWidget.toasterMessage.deleteSuccess.title"),
                    message: tLang("identityVault.monitoredInformation.socialMediaWidget.toasterMessage.deleteSuccess.message"),
                });
            })
            .catch(function (error) {
                setIsLoading(false);
                Notification({
                    type: "error",
                    title: tLang("identityVault.monitoredInformation.socialMediaWidget.toasterMessage.deleteError.title"),
                    message: tLang("identityVault.monitoredInformation.socialMediaWidget.toasterMessage.deleteError.message"),
                    duration: 0,
                });
            });
    };

    const renderAvtiveSocialMedia = () => {
        if (props.socialMediaName.toLowerCase() === "youtube") {
            return (
                <React.Fragment>
                    <span className="data-icon color-youtube">
                        <img className="text-align-center inline-block" src={YoutubeIcon} alt="YouTube icon" />
                    </span>{" "}
                    {props.accountInformation}
                </React.Fragment>
            );
        }
        if (props.socialMediaName.toLowerCase() === "twitter") {
            return (
                <React.Fragment>
                    <span className="data-icon color-youtube">
                        <img className="text-align-center inline-block" src={TwitterXIcon} alt="X icon" />
                    </span>{" "}
                    {props.accountInformation}
                </React.Fragment>
            );
        } else {
            return (
                <React.Fragment>
                    <span className={"data-icon color-" + props.socialMediaName.toLowerCase()}>
                        <em className={"lab la-" + props.socialMediaName.toLowerCase() + (props.socialMediaName.toLowerCase() === "facebook" ? "-f" : "")}></em>
                    </span>{" "}
                    {props.accountInformation}
                </React.Fragment>
            );
        }
    };

    return (
        <div role="row" className={`data-row row ${isLoading && "loading"}`}>
            <div className="col-xs-12 col-sm-4 col-no-gutter">
                <div role="gridcell" className="data-label" id={"label-" + props.socialMediaName.toLowerCase()}>
                    {(props.socialMediaName === "YouTube" || props.socialMediaName.toLowerCase() === "instagram") ? (
                        <div className="box-title-icon-info" aria-hidden="true">
                            {" "}
                            {props.socialMediaName}
                            <span className="tooltip-container" style={{ padding: "2px", fontSize: "1rem" }}>
                                <em className="las la-info-circle" aria-hidden="true"></em>
                                <span className="tooltip-text-icon">
                                    {getTooltipMsg(props.socialMediaName)}
                                </span>
                            </span>
                        </div>
                    ) : (props.socialMediaName === "Twitter") ? (
                        "X"
                    ) : (
                        props.socialMediaName
                    )}
                </div>
            </div>
            <div className="col-xs-11 col-sm-7 col-no-gutter">
                <div role="gridcell" className={"data-value " + (active ? "has-gfx" : "")} aria-labelledby={"label-" + props.socialMediaName.toLowerCase()}>
                    {active ? (
                        renderAvtiveSocialMedia()
                    ) : (
                        <button type="button" className="btn-default btn-primary btn-table btn-social-media-add-acc" onClick={addAccount}>
                            <span className="btn-text">{props.addLinkText}</span>
                        </button>
                    )}
                </div>
            </div>
            <div role="gridcell" className=" col-xs-1 col-sm-1 col-no-gutter flex-grow-null text-align-right">
                <div className="data-value">
                    {active ? (
                        <button
                            type="button"
                            className="btn-default btn-secondary-outline btn-table btn-icon-only btn-no-border btn-no-padding btn-remove-item"
                            onClick={removeAccount}
                            aria-label="Remove Account"
                        >
                            <span className="btn-icon">
                                <em className="las la-trash-alt"></em>
                            </span>
                            <span className="btn-text">{"Remove " + props.socialMediaName + " account " + props.accountInformation}</span>
                        </button>
                    ) : (
                        <></>
                    )}
                </div>
            </div>
            {isNotSupportVisible && (
                <div className="dialog-center">
                    <DialogComponent dialogId="dialog-download-not-support" title="Download Not Supported" closeDialog={closeNotSupportDialog}>
                        <SocialMediaNotSupported closeDialog={closeNotSupportDialog} />
                    </DialogComponent>
                </div>
            )}
        </div>
    );
};

export default SocialMedia;
